import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs'

class SwiperComponent extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.autoplayInterval = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  init() {
    this.setupStructure();
    this.swiperInit();
  }

  setupStructure() {
    this.wrapper = this.querySelector('[data-swipper-wrapper]');
    this.slides = this.querySelectorAll('[data-swipper-slide]');
    this.prevButton = this.querySelector('[data-swipper-prev]');
    this.nextButton = this.querySelector('[data-swipper-next]');
    this.pagination = this.querySelector('[data-swipper-pagination]');

    this.slidedPerView = this.getAttribute('data-slides-per-view');
    this.spaceBetween = Number(this.getAttribute('data-space-d'));
    this.spaceBetweenM = Number(this.getAttribute('data-space-m'));
    this.swiperOptions = JSON.parse(this.getAttribute('data-swipper-options'))

    this.totalSlides = this.slides.length;
  }

  swiperInit(){
    const swiperOptions = {
      // freeMode: true,
      // grabCursor: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      }
    }
    if (this.swiperOptions) {
      Object.assign(swiperOptions, this.swiperOptions);
    }else{
      swiperOptions.slidesPerView = this.slidedPerView;
    }
    if(this.pagination){
      swiperOptions.pagination = {
        el: this.pagination,
        clickable: true,
      };
    }

    this.swiper = new Swiper(this, swiperOptions)
  
  }

  stopAutoplay() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}

customElements.define('swiper-component', SwiperComponent);